module.exports = __webpack_public_path__ + "img/plan_name.b7042b29.svg";